import React from 'react';

class Index extends React.PureComponent<{}> {
  render() {
    return <h1>Index</h1>;
  }
}

export default Index;
